module.exports = __webpack_public_path__ + "static/media/nordtec.dd8338d9.png";